import api from './api';

interface GuidelineHit {
  lender_id: number;
  policy: string;
  description: string;
}

export const filterByLendersAndPolicies = async (lenders: string[], policies: string[]) => {
  const { data } = await api.post('guidelines/rate-compare', { lenders, policies });

  return data;
};

export const algoliaClient = () => ({
  search: async (requests: { indexName: string; params: Record<string, unknown> }[]) => {
    const { data } = await api.post('guidelines/search', { requests });

    return data;
  },
});

export const resolveLendersFromBrokerageStatuses = (user: {
  features: { has_brokerage: boolean };
  brokerage: { statuses: { lender_id: number }[] };
}) =>
  user.features.has_brokerage
    ? user.brokerage.statuses.map((status) => `lender_id:${status.lender_id}`).join(' OR ')
    : '';

export const getUniqueLenderNamesFromProducts = (products: { lender?: { name?: string } }[] = []): string[] => [
  ...new Set(products.map((product) => product?.lender?.name).filter((name): name is string => Boolean(name))),
];

export const mapGuidelinesByLenderIdAndPolicy = (guidelines: GuidelineHit[] = []) =>
  guidelines.reduce<Record<number | string, Record<string, GuidelineHit>>>((byLenderId, guideline) => {
    if (!byLenderId[guideline.lender_id]) {
      byLenderId[guideline.lender_id] = {};
    }

    byLenderId[guideline.lender_id][guideline.policy] = guideline;
    return byLenderId;
  }, {});
